import React from 'react';

function MultiPanel({ children }) {
  // Allow passing in a single child. Not entirely useful, but probably will
  // occur during development.
  if (!Array.isArray(children)) {
    children = [children];
  }

  return (
    <div className='multi-panel'>
      <div className='multi-panel__columns'>
        {children.filter(Boolean).map((panel, index) => {
          if (
            panel.props.className &&
            panel.props.className.includes('multi-panel__column')
          )
            return <React.Fragment key={index}>{panel}</React.Fragment>;
          else
            return (
              <div key={index} className='multi-panel__column'>
                {panel}
              </div>
            );
        })}
      </div>
    </div>
  );
}

export default MultiPanel;
